import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';

export const isLIHPProfileBarEnabled = (preview: boolean = false) => {
  if (preview) {
    return GrowthDiscoveryEpicClient.preview('enableLIHPProfileBar');
  } else {
    return GrowthDiscoveryEpicClient.get('enableLIHPProfileBar');
  }
};
